import { Injectable } from '@angular/core'
import { RenameTemplateDialogComponent } from './rename-template-dialog.component'
import { ContractTemplate } from '@tokeet-frontend/signature'
import { DialogService } from '@tokeet-frontend/tv3-platform'

@Injectable({
  providedIn: 'root',
})
export class RenameTemplateDialogService {
  constructor(private dialog: DialogService) {}

  public open(template: ContractTemplate) {
    return this.dialog.openFixedDialog(RenameTemplateDialogComponent, {
      width: '500px',
      data: { template },
    })
  }
}
